import Parse, { User } from 'parse'
import moment from 'moment-timezone'
import { param } from 'jquery';

moment.tz.setDefault('America/Mexico_City');

class League extends Parse.Object {
  constructor() {
    super('League');
  }

  get createdAt () {
    return this.get('createdAt')
  }

  get name () {
    return this.get('name')
  }

  dump () {
    console.log(this)
  }
}

export default League
